// Полоса перехода (задача D5, ui-spec §5): переход дольше 300 мс (грузится кусок сборки экрана) — тонкая полоса 2 px
// сверху. Быстрый переход полосы не показывает: мигание хуже ожидания. Движение — .nav-progress (motion.css).
// Полоса только для глаз: чтению с экрана о новом экране скажет фокус на его заголовке (route-focus).
import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router';

/** Через сколько мс перехода показывать полосу. */
export const NAV_PROGRESS_DELAY_MS = 300;

export function NavProgress() {
  const navigation = useNavigation();
  // Какой переход ждёт дольше 300 мс: ключ адреса, куда идём. Полоса видна, пока идёт именно он.
  const target = navigation.state === 'idle' ? null : (navigation.location?.key ?? navigation.state);
  const [slowTarget, setSlowTarget] = useState<string | null>(null);

  useEffect(() => {
    if (target === null) return undefined;
    const timer = setTimeout(() => {
      setSlowTarget(target);
    }, NAV_PROGRESS_DELAY_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [target]);

  if (target === null || slowTarget !== target) return null;
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-x-0 top-0 z-60 h-0.5 overflow-hidden">
      <div className="nav-progress h-full w-full bg-ring" />
    </div>
  );
}
